"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.optionColumns = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const classFunctions_1 = require("../../../../utils/classFunctions");
const roundMoney_1 = require("../../../../utils/roundMoney");
const idColumn_1 = require("../../../Table/columns/idColumn");
const actionsColumn_1 = require("./actionsColumn");
const optionColumns = (config) => {
    var _a, _b, _c;
    return ([
        (0, idColumn_1.idColumn)({
            hidden: (_a = config.id) === null || _a === void 0 ? void 0 : _a.hidden,
        }),
        {
            id: 'name',
            Header: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Rate/Option/List/Column/Name:Title', defaultMessage: 'Name' })),
            Cell: ({ row }) => {
                const className = 'rate-option-list-code';
                const classNames = (0, classFunctions_1.getClassNames)(className, []);
                const option = row.original;
                const { code } = option;
                return (react_1.default.createElement("div", { className: classNames }, code));
            },
            hidden: (_b = config.name) === null || _b === void 0 ? void 0 : _b.hidden,
        },
        {
            id: 'isDefaultChecked',
            Header: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Rate/Option/List/Column/CheckedByDefault:Title', defaultMessage: 'Checked by default' })),
            Cell: ({ row }) => {
                const className = 'rate-option-list-checked-by-default';
                const classNames = (0, classFunctions_1.getClassNames)(className, []);
                const option = row.original;
                const { isDefaultChecked } = option.configValues;
                return (react_1.default.createElement("div", { className: classNames },
                    isDefaultChecked !== undefined && isDefaultChecked && (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Rate/Option/List/Column/CheckedByDefault:Yes', defaultMessage: 'Yes' })),
                    isDefaultChecked !== undefined && !isDefaultChecked && (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Rate/Option/List/Column/CheckedByDefault:No', defaultMessage: 'No' }))));
            },
            hidden: (_c = config.isDefaultChecked) === null || _c === void 0 ? void 0 : _c.hidden,
        },
        {
            id: 'price',
            Header: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Rate/Option/List/Column/Price:Title', defaultMessage: 'Price' })),
            Cell: ({ row }) => {
                const className = 'rate-option-list-price';
                const classNames = (0, classFunctions_1.getClassNames)(className, []);
                const { locale } = (0, react_intl_1.useIntl)();
                const option = row.original;
                const { price } = option.configValues;
                return (react_1.default.createElement("div", { className: classNames }, (0, roundMoney_1.localizeMoney)(price, locale, 'Rate/Option/List/columns/price')));
            },
        },
        (0, actionsColumn_1.optionActionsColumn)(config.actions),
    ]);
};
exports.optionColumns = optionColumns;
//# sourceMappingURL=tableColumns.js.map